import React from 'react';
import PageHero from '../../components/PageHero';
import LeadershipSection from '../../components/LeadershipSection';
import CTASection from '../../components/CTASection';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const Management = () => {
  useDocumentTitle('Management');

  return (
    <>
      <PageHero
        eyebrow="Leadership"
        title="The team behind"
        titleAccent="iConnect."
        breadcrumbs={[
          { label: 'About', to: '/about' },
          { label: 'Management' },
        ]}
        subhead="iConnect is run by the people who built the EDI industry - former leaders from Harbinger, Premenos, Sterling Commerce, and Supply Tech. Combined, our leadership team brings 100+ years of EDI experience."
      />
      <LeadershipSection />
      <CTASection />
    </>
  );
};

export default Management;
